import { forwardRef, type SVGProps } from "react";

interface ArchiveIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const ArchiveIcon = forwardRef<SVGSVGElement, ArchiveIconProps>(
  ({ ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M16.3889 6.94531V14.7231C16.3889 15.9509 15.3944 16.9453 14.1666 16.9453H5.83331C4.60553 16.9453 3.61108 15.9509 3.61108 14.7231V6.94531"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9443 3.05469H3.05545C2.4418 3.05469 1.94434 3.55215 1.94434 4.1658V5.83247C1.94434 6.44611 2.4418 6.94358 3.05545 6.94358H16.9443C17.558 6.94358 18.0554 6.44611 18.0554 5.83247V4.1658C18.0554 3.55215 17.558 3.05469 16.9443 3.05469Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.77759 10.2773H12.222"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

ArchiveIcon.displayName = "ArchiveIcon";

interface BellIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  height?: number | string;
  width?: number | string;
}

export const BellIcon = forwardRef<SVGSVGElement, BellIconProps>(
  ({ color = "white", height = 18, width = 17, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 18"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M5.67147 13.25V13.875C5.67147 14.538 5.93487 15.1739 6.40371 15.6427C6.87255 16.1116 7.50843 16.375 8.17147 16.375C8.83452 16.375 9.4704 16.1116 9.93924 15.6427C10.4081 15.1739 10.6715 14.538 10.6715 13.875V13.25M2.56234 6.37495C2.5613 5.63371 2.70699 4.89959 2.99099 4.21491C3.275 3.53024 3.69172 2.90854 4.21711 2.38567C4.74251 1.86279 5.36621 1.44907 6.05224 1.16837C6.73828 0.887656 7.47309 0.745506 8.21432 0.750108C11.3073 0.773102 13.7812 3.34396 13.7812 6.44557V8.24995C13.7812 11.048 14.9916 11.4217 15.5072 12.3092C15.5628 12.404 15.5923 12.5118 15.5929 12.6217C15.5935 12.7316 15.5651 12.8397 15.5106 12.9351C15.4561 13.0305 15.3773 13.1099 15.2824 13.1651C15.1874 13.2204 15.0795 13.2497 14.9696 13.25H1.37332C1.26341 13.2497 1.15553 13.2204 1.06054 13.1651C0.965556 13.1098 0.886832 13.0305 0.832311 12.935C0.777791 12.8396 0.749402 12.7315 0.75001 12.6216C0.750617 12.5117 0.780198 12.4039 0.835769 12.309C1.35165 11.4216 2.56233 11.0479 2.56233 8.24995L2.56234 6.37495Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
BellIcon.displayName = "BellIcon";

interface CalendarIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const CalendarIcon = forwardRef<SVGSVGElement, CalendarIconProps>(
  ({ color = "white", ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        {...props}
        ref={ref}
      >
        <path
          d="M2 8.22222V5.72222C2 4.8938 2.67157 4.22222 3.5 4.22222H4.97488M2 8.22222V16.5C2 17.3284 2.67157 18 3.5 18H16.5C17.3284 18 18 17.3284 18 16.5V8.22222M2 8.22222H18M18 8.22222V5.72222C18 4.8938 17.3284 4.22222 16.5 4.22222H15.0249M15.0249 4.22222V2M15.0249 4.22222H4.97488M4.97488 4.22222V2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="10.3125" cy="11.5625" r="0.9375" fill={color} />
        <circle cx="10.3125" cy="14.6875" r="0.9375" fill={color} />
        <circle cx="6.5625" cy="14.6875" r="0.9375" fill={color} />
        <circle cx="14.0625" cy="11.5625" r="0.9375" fill={color} />
        <circle cx="14.0625" cy="14.6875" r="0.9375" fill={color} />
      </svg>
    );
  },
);
CalendarIcon.displayName = "CalendarIcon";

type LightningBoltIconProps = SVGProps<SVGSVGElement> & {
  filled?: boolean;
  fillColor?: string;
  strokeColor?: string;
};

export const LightningBoltIcon = forwardRef<
  SVGSVGElement,
  LightningBoltIconProps
>(
  (
    {
      filled = false,
      fillColor = "currentColor",
      strokeColor = "currentColor",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        aria-hidden="true"
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3006 1.04633C11.7169 1.17755 12 1.5636 12 2.00007V7.00007L16 7.00007C16.3729 7.00007 16.7148 7.20753 16.887 7.53826C17.0592 7.86899 17.0331 8.26806 16.8192 8.57353L9.81924 18.5735C9.56894 18.9311 9.11564 19.085 8.69936 18.9538C8.28309 18.8226 8 18.4365 8 18.0001L8 13.0001H4C3.62713 13.0001 3.28522 12.7926 3.11302 12.4619C2.94083 12.1312 2.96694 11.7321 3.18077 11.4266L10.1808 1.42661C10.4311 1.06904 10.8844 0.915114 11.3006 1.04633Z"
          fill={filled ? fillColor : "none"}
          stroke={!filled ? strokeColor : "none"}
          strokeWidth={!filled ? 1.5 : 0}
        />
      </svg>
    );
  },
);
LightningBoltIcon.displayName = "LightningBoltIcon";

interface LockIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const LockIcon = forwardRef<SVGSVGElement, LockIconProps>(
  ({ color = "#808080", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden={true}
        role="img"
      >
        <title>Lock Icon</title>
        <path
          d="M8.00008 10V11.3333M4.00008 14H12.0001C12.7365 14 13.3334 13.403 13.3334 12.6667V8.66667C13.3334 7.93029 12.7365 7.33333 12.0001 7.33333H4.00008C3.2637 7.33333 2.66675 7.93029 2.66675 8.66667V12.6667C2.66675 13.403 3.2637 14 4.00008 14ZM10.6667 7.33333V4.66667C10.6667 3.19391 9.47284 2 8.00008 2C6.52732 2 5.33341 3.19391 5.33341 4.66667V7.33333H10.6667Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  },
);
LockIcon.displayName = "LockIcon";

interface LogoutIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
}

export const LogoutIcon = forwardRef<SVGSVGElement, LogoutIconProps>(
  ({ color = "white", title = "Logout", ...props }, ref) => {
    return (
      <svg
        aria-hidden="true"
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <title>{title}</title>
        <path
          d="M8.03844 2.5L5 2.5C3.4467 2.5 2.5 3.4467 2.5 5L2.5 15C2.5 16.5533 3.4467 17.5 5 17.5L8.03844 17.5M13.75 13.75L17.5 10M17.5 10L13.75 6.25M17.5 10L6.80796 10"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
LogoutIcon.displayName = "LogoutIcon";

interface MagnifyingGlassIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const MagnifyingGlassIcon = forwardRef<
  SVGSVGElement,
  MagnifyingGlassIconProps
>(({ color = "#808080", ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      ref={ref}
    >
      <path
        d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z"
        stroke={color}
        strokeOpacity="0.933333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
MagnifyingGlassIcon.displayName = "MagnifyingGlassIcon";

type PenIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const PenIcon = forwardRef<SVGSVGElement, PenIconProps>(
  ({ color = "white", ...props }, ref) => {
    return (
      <svg
        aria-hidden="true"
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M11.958 4.91076L15.084 8.03035M13.7265 3.14609C14.5897 2.28464 15.9894 2.28464 16.8526 3.14609C17.7158 4.00754 17.7158 5.40423 16.8526 6.26568L5.59468 17.5H2.5V14.3491L13.7265 3.14609Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
PenIcon.displayName = "PenIcon";

interface PlusBoxedIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  title?: string;
}

export const PlusBoxedIcon = forwardRef<SVGSVGElement, PlusBoxedIconProps>(
  ({ color = "white", title = "Plus boxed icon", ...props }, ref) => {
    return (
      <svg
        aria-label="true"
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M14.7223 3.05469H5.27789C4.05059 3.05469 3.05566 4.04961 3.05566 5.27691V14.7214C3.05566 15.9487 4.05059 16.9436 5.27789 16.9436H14.7223C15.9496 16.9436 16.9446 15.9487 16.9446 14.7214V5.27691C16.9446 4.04961 15.9496 3.05469 14.7223 3.05469Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 10H13.125"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.875V13.125"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
PlusBoxedIcon.displayName = "PlusBoxedIcon";

interface ProfileIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const ProfileIcon = forwardRef<SVGSVGElement, ProfileIconProps>(
  ({ ...props }, ref) => {
    return (
      <svg
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M2.5658 13.4861C2.37802 13.8553 2.52509 14.3068 2.89429 14.4946C3.26349 14.6824 3.71502 14.5353 3.9028 14.1661L3.2343 13.8261L2.5658 13.4861ZM12.5972 14.1661C12.785 14.5353 13.2365 14.6824 13.6057 14.4946C13.9749 14.3068 14.122 13.8553 13.9342 13.4861L13.2657 13.8261L12.5972 14.1661ZM15.75 8.25H15C15 11.9779 11.9779 15 8.25 15V15.75V16.5C12.8063 16.5 16.5 12.8063 16.5 8.25H15.75ZM8.25 15.75V15C4.52208 15 1.5 11.9779 1.5 8.25H0.75H0C0 12.8063 3.69365 16.5 8.25 16.5V15.75ZM0.75 8.25H1.5C1.5 4.52208 4.52208 1.5 8.25 1.5V0.75V0C3.69365 0 0 3.69365 0 8.25H0.75ZM8.25 0.75V1.5C11.9779 1.5 15 4.52208 15 8.25H15.75H16.5C16.5 3.69365 12.8063 0 8.25 0V0.75ZM3.2343 13.8261L3.9028 14.1661C4.31084 13.3639 4.93292 12.6902 5.70018 12.2196L5.30807 11.5803L4.91597 10.9409C3.91274 11.5562 3.09934 12.4371 2.5658 13.4861L3.2343 13.8261ZM5.30807 11.5803L5.70018 12.2196C6.46743 11.7491 7.34993 11.5 8.24999 11.5L8.24999 10.75L8.24999 10C7.07311 10 5.9192 10.3257 4.91597 10.9409L5.30807 11.5803ZM8.24999 10.75L8.24999 11.5C9.15005 11.5 10.0325 11.7491 10.7998 12.2196L11.1919 11.5803L11.584 10.9409C10.5808 10.3257 9.42686 10 8.24999 10L8.24999 10.75ZM11.1919 11.5803L10.7998 12.2196C11.5671 12.6902 12.1891 13.3638 12.5972 14.1661L13.2657 13.8261L13.9342 13.4861C13.4006 12.4371 12.5872 11.5562 11.584 10.9409L11.1919 11.5803ZM11.375 7.625H10.625C10.625 8.93667 9.56167 10 8.24999 10V10.75V11.5C10.3901 11.5 12.125 9.76511 12.125 7.625H11.375ZM8.24999 10.75V10C6.93832 10 5.875 8.93668 5.875 7.625H5.125H4.375C4.375 9.7651 6.10988 11.5 8.24999 11.5V10.75ZM5.125 7.625H5.875C5.875 6.31332 6.93832 5.25 8.25 5.25V4.5V3.75C6.1099 3.75 4.375 5.4849 4.375 7.625H5.125ZM8.25 4.5V5.25C9.56168 5.25 10.625 6.31332 10.625 7.625H11.375H12.125C12.125 5.4849 10.3901 3.75 8.25 3.75V4.5Z"
          fill="white"
        />
      </svg>
    );
  },
);
ProfileIcon.displayName = "ProfileIcon";

interface SubscriptionIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const SubscriptionIcon = forwardRef<
  SVGSVGElement,
  SubscriptionIconProps
>(({ ...props }, ref) => {
  return (
    <svg
      ref={ref}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6.56592 14.0234L3.07217 13.4074L2.45613 16.9011"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8407 9.86708C17.8773 11.9193 17.1082 13.9787 15.5436 15.5433C12.482 18.6049 7.51707 18.6031 4.45723 15.5433C3.92508 15.0112 3.49404 14.4311 3.1446 13.805"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.434 5.97711L16.9278 6.59315L17.5438 3.0994"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16174 10.132C2.13159 8.08641 2.89318 6.02036 4.45715 4.45638C7.51877 1.39476 12.4837 1.39654 15.5435 4.45636C16.0579 4.97077 16.4846 5.53746 16.8243 6.1379"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99991 7.33355C8.93727 7.33355 8.33325 7.9305 8.33325 8.66688C8.33325 9.40326 8.93727 10.0002 9.99991 10.0002C11.0626 10.0002 11.6666 10.5972 11.6666 11.3335C11.6666 12.0699 11.0626 12.6669 9.99993 12.6669M9.99991 7.33355C10.7121 7.33355 11.3339 7.60168 11.6666 8.00022M9.99991 7.33355L9.99992 6.11133M9.99993 12.6669L9.99992 13.8891M9.99993 12.6669C9.28775 12.6669 8.66593 12.3987 8.33325 12.0002"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
});
SubscriptionIcon.displayName = "SubscriptionIcon";
